<template>

	<div class="image-banner">
		<div class="image-banner-image">
			<img :src="src" :alt="languageStore.getString('banner_image')" />
		</div>
		<div class="image-banner-content">
			<div class="title-row">
				<h4>{{ title }}</h4>
			</div>
			<p>{{ text }}</p>
		</div>
		<div class="image-banner-close" v-html="getIcon('iconX')" @click="$emit('close')"></div>
	</div>

</template>

<script>
import {useSvgStore, useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		let svgStore = useSvgStore();
		let languageStore = useLanguageStore();
		return {getIcon: svgStore.get, languageStore};
	},
	name: "AppImageBanner",
	emits: ['close'],
	data() {
		return {

		}
	},
	props: {
		src: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		}
	},
	methods: {

	},
}
</script>

<style lang="scss" scoped>
.image-banner {
	@include centered;
	position: relative;
	padding: 20px;
	border-radius: 13px;
	background-color: rgba(7, 82, 163, 0.10);

	.image-banner-image {
		width: 80px;
		height: 80px;

		img {
			width: 80px;
			height: 80px;
			border-radius: 13px;
		}
	}
	.image-banner-content {
		width: calc(100% - 80px);
		padding-left: 20px;

		.title-row {
			@include centered;
			justify-content: space-between;

			h4 {
				color: $primary;
				max-width: calc(100% - 20px);
			}
		}
	}

	.image-banner-close {
		position: absolute;
		top: 22px;
		right: 22px;
		width: 14px;
		height: 14px;
		cursor: pointer;

		&:deep(svg) {
			width: 100%;
			height: 100%;
			.fill { fill: $primary; }
			.stroke { stroke: $primary; }
		}
	}

	@media (max-width: 480px) {
		padding: 12px;
		flex-direction: column;

		.image-banner-image {
			width: 140px;
			height: 140px;
			img {
				width: 140px;
				height: 140px;
			}
		}
		.image-banner-content {
			width: 100%;
			padding-left: 0;
			margin-top: 14px;
		}
		.image-banner-close {
			top: 12px;
			right: 12px;
		}
	}
}
</style>